import { render, staticRenderFns } from "./orders-status-repair-stages.vue?vue&type=template&id=bc4f71a0"
import script from "./orders-status-repair-stages.vue?vue&type=script&lang=js"
export * from "./orders-status-repair-stages.vue?vue&type=script&lang=js"
import style0 from "./orders-status-repair-stages.vue?vue&type=style&index=0&id=bc4f71a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports